import { createAction, props } from '@ngrx/store';
import { M365Range } from './model';

export const loadM365Ranges = createAction('[M365 Ranges] Load');

export const loadM365RangesSuccess = createAction('[M365 Ranges] Load Success', props<{ data: M365Range[] }>());

export const loadM365RangesFailure = createAction('[M365 Ranges] Load Failure', props<{ error: any }>());
